// extracted by mini-css-extract-plugin
module.exports = {"Title":"CocktailForm_Title__zH72G","CocktailForm":"CocktailForm_CocktailForm__Q_luk","SubmitButton":"CocktailForm_SubmitButton__1zpSW","Error":"CocktailForm_Error__2XhbM"};